import { TwoSideToggleStyles } from '@dealstack/frontend/shared/components/TwoSideToggle/TwoSideToggle.styles.tsx';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

interface Props {
	leftLabel: string;
	rightLabel: string;
	toggled: boolean;
	onToggle: (toggled: boolean) => void;
}

export const TwoSideToggle = ({ leftLabel, rightLabel, toggled, onToggle }: Props) => {
	return (
		<TwoSideToggleStyles>
			<AdvancedSwitch
				selectedValue={toggled}
				onChange={(e) => {
					onToggle(!!e);
				}}
				leftText={leftLabel}
				rightText={rightLabel}
				size="m"
				selectedColor="dark.8"
				justify="space-between"
				className="switch"
			/>
		</TwoSideToggleStyles>
	);
};
